/* CFR: menus and focus management are handled by the native theme. */
(()=>{document.addEventListener('click',event=>{const link=event.target.closest('[data-cf-quote]');if(!link)return;window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'cf_b2b_quote_click',placement:link.closest('header')?'header':'footer'});});})();

/* CFR — 29/09/2026: suppress Klaviyo overlays only in the B2B universe.
   Do not close via Klaviyo: that would persist a dismissal for B2C visits.
   CSS hides the overlay; this releases only Klaviyo's own scroll lock.
   Embedded forms, tracking, native dialogs and consent remain unchanged. */
(() => {
  const body = document.body;
  if (!body.classList.contains('cf-universe-b2b')) return;
  const selector = '[role="dialog"][class*="kl-private-reset-css"]';
  const suppress = () => {
    if (body.classList.contains('klaviyo-prevent-body-scrolling')) {
      body.classList.remove('klaviyo-prevent-body-scrolling');
    }
    document.querySelectorAll(selector).forEach(dialog => {
      if (!dialog.inert) dialog.inert = true;
    });
  };
  suppress();
  new MutationObserver(suppress).observe(body, { childList: true, subtree: true });
  new MutationObserver(suppress).observe(body, { attributes: true, attributeFilter: ['class'] });
})();
